export const featureFlagUpdateEventName = 'featureFlagUpdate';